/**
 * Application Constants
 */

// Role Settings
export const ROLE_DEFAULT = 0;
export const ROLE_CUSTOM = 1;

// Role Default Values
export const DEFAULT_ROLE_VALUE = ROLE_DEFAULT;

// License Status Types
export const LICENSE_STATUS_WAITING = 0;
export const LICENSE_STATUS_APPROVE = 1;
export const LICENSE_STATUS_REJECT = 2;
export const LICENSE_STATUS_ACTIVE = 3;
export const LICENSE_STATUS_EXPIRED = 4;
export const LICENSE_STATUS_REVOKED = 5;

// Device Status Types
export const DEVICE_STATUS_WAITING = 0;
export const DEVICE_STATUS_APPROVED = 1;
export const DEVICE_STATUS_REJECTED = 2;
export const DEVICE_STATUS_ACTIVE = 3;
export const DEVICE_STATUS_REVOKED = 4;

// Subordinate Level Types (Cấp trực thuộc)
export const SUBORDINATE_LEVEL_BTL86 = 1; // Trực thuộc Bộ Tư Lệnh 86
export const SUBORDINATE_LEVEL_SHARED_BTL86 = 2; // Có hệ thống nhưng dùng chung với BTL 86
export const SUBORDINATE_LEVEL_UNIT = 3; // Trực thuộc hoàn toàn ở đơn vị

// Subordinate Level Options for Select dropdown
export const SUBORDINATE_LEVELS = [
  {
    id: SUBORDINATE_LEVEL_BTL86,
    code: 'TRUC_THUOC_BTL86',
    name: 'Trực thuộc Bộ Tư Lệnh 86',
    nameKey: 'subordinateLevels.types.btl86',
  },
  {
    id: SUBORDINATE_LEVEL_SHARED_BTL86,
    code: 'DUNG_CHUNG_BTL86',
    name: 'Dùng chung với BTL 86',
    nameKey: 'subordinateLevels.types.sharedBtl86',
  },
  {
    id: SUBORDINATE_LEVEL_UNIT,
    code: 'TRUC_THUOC_DON_VI',
    name: 'Trực thuộc hoàn toàn đơn vị',
    nameKey: 'subordinateLevels.types.unit',
  },
];

export default {
  ROLE_DEFAULT,
  ROLE_CUSTOM,
  DEFAULT_ROLE_VALUE,
  LICENSE_STATUS_WAITING,
  LICENSE_STATUS_APPROVE,
  LICENSE_STATUS_REJECT,
  LICENSE_STATUS_ACTIVE,
  LICENSE_STATUS_EXPIRED,
  LICENSE_STATUS_REVOKED,
  DEVICE_STATUS_WAITING,
  DEVICE_STATUS_APPROVED,
  DEVICE_STATUS_REJECTED,
  DEVICE_STATUS_ACTIVE,
  DEVICE_STATUS_REVOKED,
  SUBORDINATE_LEVEL_BTL86,
  SUBORDINATE_LEVEL_SHARED_BTL86,
  SUBORDINATE_LEVEL_UNIT,
  SUBORDINATE_LEVELS,
};
